import {MODALS, DELEGATION_STATES} from 'common/domain/constants';
import {MODULE_ID, VA_DELEGATIONS_MODAL_COACHMARK_CONFIG} from 'vacations-absences.module/common/domain/constants';
import {formatDate} from 'common/utils/dateUtils/date-utils';

class VacationsAbsencesDelegationsController {
  constructor($window,
              $log,
              vacationDelegationService,
              vacationUserDataService,
              HelperDelegationsService,
              loadingMobileService,
              metricsService) {
    'ngInject';
    this.log = $log;
    this.vacationDelegationService = vacationDelegationService;
    this.vacationUserDataService = vacationUserDataService;
    this.helperDelegations = HelperDelegationsService;
    this.loadingMobileService = loadingMobileService;
    this.metricsService = metricsService;

    this.loaded = false;
    this.moduleId = MODULE_ID;
    this.userId = this.vacationUserDataService.getEmployee().userId;
    this.successTitle = 'GLOBALS.SUCCESS_DELEGATION';
    this.cancelDelegationSuccessTitle = 'GLOBALS.CANCEL_SUCCESS_DELEGATION';
    this.coachmarkData = VA_DELEGATIONS_MODAL_COACHMARK_CONFIG;
    this.isMobileApp = $window.innerWidth < 1024;
  }

  $onInit() {
    this.getDelegationsFromBack();
  }

  getDelegationsFromBack() {
    this.loadingMobileService.show();
    this.vacationDelegationService.getDelegations(this.userId)
      .then((delegations) => {
        this.delegationsObject = delegations;
        this.helperDelegations.sendEventToChangeIconDelegations();
        this.loaded = true;
      })
      .finally(() => this.loadingMobileService.hide());
  }

  get modal() {
    const $modal = $(MODALS.DELEGATIONS_MANAGER);
    $modal.on('hidden.bs.modal', () => this.closeModal());
    return $modal;
  }

  openModal({action, delegation}) {
    this.modalState = action;
    this.selectedDelegation = delegation;
    this.modal.modal('show');
  }

  closeModal() {
    this.modalState = '';
    this.selectedDelegation = {};
    this.modal.modal('hide');
  }

  sendCancelDelegation() {
    let objectToCancel = {
      startDate: this.selectedDelegation.startDate,
      employeeId: this.selectedDelegation.employeeId,
      service: MODULE_ID,
    };

    this.loadingMobileService.show();
    this.vacationDelegationService.deleteDelegation(this.userId, objectToCancel)
      .then(() => {
        this.modalState = DELEGATION_STATES.SUCCESS;
        this.modalTitle = this.cancelDelegationSuccessTitle;
        this.getDelegationsFromBack();
      }, (error) => {
        this.modalState = DELEGATION_STATES.ERROR;
        this.modalMessage = error.data.message;
        this.modalTitle = error.data.errors.codigo;
      })
      .finally(() => this.loadingMobileService.hide());
  }

  sendEditDelegation({startDate, endDate}) {
    startDate = formatDate(startDate);
    endDate = formatDate(endDate);

    let objectToSend = {
      startDate,
      endDate,
      id: this.selectedDelegation.id,
      service: MODULE_ID,
    };

    this.loadingMobileService.show();
    this.vacationDelegationService.updateDelegation(this.userId, objectToSend)
      .then(() => {
        this.modalState = DELEGATION_STATES.SUCCESS;
        this.modalTitle = this.successTitle;
        this.getDelegationsFromBack();
      }, (error) => {
        this.modalState = DELEGATION_STATES.ERROR;
        this.modalMessage = error.data.message;
        this.modalTitle = error.data.errors.codigo;
      })
      .finally(() => this.loadingMobileService.hide());
  }

  sendDelegation(delegation) {
    let startDate = formatDate(delegation.startDate);
    let endDate = formatDate(delegation.endDate);
    let employeeId = delegation.employee;

    let delegationToCreate = {
      startDate,
      endDate,
      employeeId,
      service: MODULE_ID,
    };

    this.log.info({delegationToCreate});
    this.loadingMobileService.show();
    this.vacationDelegationService.createDelegation(this.userId, delegationToCreate)
      .then(() => {
        this.modalState = DELEGATION_STATES.SUCCESS;
        this.modalTitle = this.successTitle;
        this.getDelegationsFromBack();

        this.metricsService.trackVacationsAbsencesDelegation();
      }, (error) => {
        this.modalState = DELEGATION_STATES.ERROR;
        this.modalMessage = error.data.message;
        this.modalTitle = error.data.errors.codigo;
      })
      .finally(() => this.loadingMobileService.hide());
  }
}

export default VacationsAbsencesDelegationsController;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/vacationsAbsencesDelegations/vacationsAbsencesDelegations.controller.js